import { Component, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { Customer } from 'src/app/interfaces/customer';
import { MaskedToken } from 'src/app/interfaces/masked-token';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { GeneralService } from 'src/app/services/general.service';
import { environment } from 'src/environments/environment';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-wstoken',
    templateUrl: './wstoken.component.html',
    styleUrls: ['./wstoken.component.scss'],
    standalone: false
})
export class WSTokenComponent {

     @ViewChild('showToken')
     showToken!: TemplateRef<any>;


     userProfile?: UserProfile;
     customer?: Customer;
     companyType: string = '';
     token: string = "";
     tokenMasked: string = "";
     tokenExpires: string = "";
     requesting: boolean = false;
     copied: boolean = false;
     isDownload: boolean = false;

     constructor(public generalService: GeneralService,
          private authenticationService: AuthenticationService,private modalService: NgbModal,  private router: Router) {
          this.userProfile = this.authenticationService.getUserProfile() as UserProfile;
          if (!this.userProfile!.customerId || this.userProfile!.customerId === '2147483647' || !this.userProfile!.customer) {
               this.router.navigate(['accessDenied']);
          }

          this.companyType = this.userProfile.customer.customerType === 1 ?
               'MC' :
               this.userProfile.customer.customerType === 6 ?
                    'ISP' :
                    '';

          const tokenPromise = generalService.getMaskedToken();
          tokenPromise.subscribe((token: MaskedToken | any) => {
               if (token && token.expirationDate !== null) {
                    this.tokenMasked = token.lastDigitsOfToken;
                    const expirationDateParts = token.expirationDate.split(' ');
                    this.tokenExpires = expirationDateParts[0];
               }
          });

          this.scrollToTop();
     }

     download() {
          const filename = "apitoken.txt";
          const element = document.createElement('a');
          element.setAttribute('href', 'data:application/octet-stream;utf8,' + this.token);
          element.setAttribute('download', filename);
          element.style.display = 'none';
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
          this.isDownload = true;
     }

     copyDivToClipboard() {
          const range = document.createRange();
          const Elm = document.getElementById("newTokenContent");
          if (Elm !== null) {
               range.selectNode(Elm);
               window.getSelection()?.removeAllRanges();
               window.getSelection()?.addRange(range); // to select text
               document.execCommand("copy");
               window.getSelection()?.removeAllRanges();
               this.copied = true;
          }
     }

     getToken() {

          this.requesting = true;
          this.generalService.getAPIToken().subscribe(v => {
               this.modalService.open(this.showToken, { ariaLabelledBy: 'showTokenTitle' });
               this.token = v;
               this.tokenMasked = this.token.substring(this.token.length - 4, this.token.length);
               const myDate = new Date();
               myDate.setDate(myDate.getDate() + 60);
               this.tokenExpires = ((myDate.getMonth() + 1) + "/" + myDate.getDate() + "/" + myDate.getFullYear());
               this.requesting = false;
               this.copied = false;
               this.isDownload = false;
          });
     }

     closeToken(){
          this.token = '';
          this.modalService.dismissAll();
     }

     openDocument(docName: string) {
          this.generalService.openDocument(docName);
     }

     updateUrl(url: string) {
          url = url.replace(`##docBaseUrl##`, `${environment.APP_PSP_DOC_BASE_URL}`)
               .replace(`##baseUrl##`, `${environment.APP_PSP_BASE_URL}`);
          return url;
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }
}
